import React, { Component } from "react";
import { observer } from "mobx-react";

import { distinct } from "@formant/core/common/distinct";

import { StreamFilter } from "../../store/IStreamStore";
import { streamStore } from "../../stores";
import { MultiSelect } from "./MultiSelect";
import { streamTypeIcons } from "./StreamIcon";

export interface IStreamNameSelectProps {
    streamFilter: StreamFilter;
    value: string[];
    className?: string;
    onChange: (value: string[]) => void;
}

@observer
export class StreamNameSelect extends Component<IStreamNameSelectProps> {
    private streamNames: string[] = [];
    public render() {
        const { streamFilter, value, className, onChange } = this.props;
        const streamNameTypeMap = streamStore.streamNameTypeMap;
        const streamNameAliasOrNameMap = streamStore.streamNameAliasOrNameMap;
        this.streamNames =
            streamStore.getStreamNames(streamFilter) || this.streamNames;
        const streamNames = this.streamNames;
        const options = distinct([...streamNames, ...value])
            .sort()
            .map(streamName => {
                const streamType = streamNameTypeMap?.get(streamName);
                const icon = streamType && streamTypeIcons[streamType];
                const label = streamNameAliasOrNameMap?.get(streamName);
                return {
                    value: streamName,
                    icon,
                    label,
                };
            });
        if (options.length === 0) {
            return false;
        }
        const disabled = value.length === 0 && options.length === 1;
        return (
            <MultiSelect
                value={value}
                title="Stream"
                options={options}
                className={className}
                onChange={onChange}
                disabled={disabled}
            />
        );
    }
}
